import {
  Avatar,
  AvatarFallback,
  AvatarImage,
  type AvatarSize,
} from "@/components/ui/avatar";
import { cn } from "@/lib/utils";
import { BuildingIcon } from "@phosphor-icons/react";

interface CompanyAvatarProps {
  logo: string | null;
  name: string;
  size?: AvatarSize;
  className?: string;
}

export function CompanyAvatar({
  logo,
  name,
  size = "md",
  className,
}: CompanyAvatarProps) {
  return (
    <Avatar size={size} className={cn("rounded", className)}>
      <AvatarImage src={logo || undefined} alt={name} />
      <AvatarFallback className="rounded bg-foreground! dark:bg-slate-500/25!">
        {/* Half the avatar, whatever its size. */}
        <BuildingIcon className="size-1/2" />
      </AvatarFallback>
    </Avatar>
  );
}
